module.exports = __webpack_public_path__ + "static/media/icon-dog.8fd35b9f.svg";